module.exports = __webpack_public_path__ + "static/media/edu_prog.ebb5ef51.png";